module.exports = __webpack_public_path__ + "96b537af478e2680010e3a6d1022e186.svg";